export default [
  { title: "The Phantom Menace", episode_id: 1, photoUrl: "/assets/The-Phantom-Menace.jpg" },
  { title: "Attack of the Clones", episode_id: 2, photoUrl: "/assets/Attack-of-the-Clones.jpg" },
  { title: "Revenge of the Sith", episode_id: 3, photoUrl: "/assets/Revenge-of-the-Sith.jpg" },
  { title: "A New Hope", episode_id: 4, photoUrl: "/assets/A-New-Hope.jpg" },
  {
    title: "The Empire Strikes Back",
    episode_id: 5,
    photoUrl: "/assets/The-Empire-Strikes-Back.jpg"
  },
  { title: "Return of the Jedi", episode_id: 6, photoUrl: "/assets/return-of-the-jedi.jpg" }
];
